/// <reference path="input.ts" />

/**
 * <dl>
 * <dt>属性</dt>
 * </dl>
 * その他の属性はKoyoriInputに依存します。
 */
class KoyoriInputTextarea extends KoyoriInput {

	constructor() {
		super();
	}

	connectedCallback(): void {
		super.connectedCallback();
		
		let value = this.getAttribute('value');
		if (value != null) {
			this.value = value.replace(/\\n/g, '\n').replace(/\\r/g, '\r');
		}
	}

	/**
	 * @return 設定されている値
	 */
	get value(): string {
		return (<HTMLTextAreaElement>this.inputElement).value;
	}

	/**
	 * @param value 設定する値
	 */
	set value(value: string) {
		(<HTMLTextAreaElement>this.inputElement).value = value;
	}

	/**
	 * @return 入力タグ。
	 */
	protected getInputTag(): string {
		return 'textarea';
	}
	
	/**
	 * @return 入力タグのtype属性の値
	 */
	protected getInputType(): string {
		return null;
	}

}
window.customElements.define('koy-input-textarea', KoyoriInputTextarea);
